import _ from 'underscore';
import moment from 'moment';

angular.module('am4').controller('calendarEventCtrl', function($q, $scope, $stateParams, $translate, $rootScope, config, calendarService, event, timezone, errorService, Analytics) {
    var PLURALITY = {
            week: ['ONE_WEEK', 'N_WEEKS'],
            month: ['ONE_MONTH', 'N_MONTHS'],
            year: ['ONE_YEAR', 'N_YEARS']
        },
        that = this;

    that.type = $stateParams.event_id ? 'EDIT' : 'NEW';
    that.event_id = $stateParams.event_id;
    that.facility_id = $stateParams.id;
    that.timezone = timezone;

    that.now = moment().seconds(0).milliseconds(0).toDate();
    that.startDateOpts = {
        dateFormat: config.flatpickrDateFormat,
        altInput: true, // Display the date to the user in a 2nd <input> element
        altFormat: config.flatpickrDisplayFormat,
        altFormat12hr: config.flatpickrDisplayFormat12hr,
        enableTime: true,
        time_24hr: true,
        timezone: timezone || 'UTC',
        disableMobile: true, // Don't use the native datetime picker on mobile devices
        minuteIncrement: 1,
        static: true, // Ensures keyboard accessibility when flatPickr is rendered within a modal window
        position: 'above',
        onChange: function() {
            if (moment(that.fpEndItem.latestSelectedDateObj).isBefore(that.fpStartItem.latestSelectedDateObj)) {
                let newEnd = moment(that.fpStartItem.latestSelectedDateObj).format();
                if (that.event.duration.value !== 'custom') {
                    newEnd = moment(that.fpStartItem.latestSelectedDateObj).add(that.event.duration.value, 'minutes').format();
                }
                that.fpEndItem.setDate(newEnd);
            } else {
                that.event.duration = determineDuration(that.fpStartItem.latestSelectedDateObj, that.fpEndItem.latestSelectedDateObj, that.durationOptions);
            }
        }
    };
    that.endDateOpts = angular.copy(that.startDateOpts);
    that.endDateOpts.onChange = function() {
        if (moment(that.fpEndItem.latestSelectedDateObj).isBefore(that.fpStartItem.latestSelectedDateObj)) {
            that.fpEndItem.setDate(that.fpStartItem.latestSelectedDateObj);
        }
        if (that.event.allDay && moment(that.fpEndItem.latestSelectedDateObj).format() !== moment(that.fpEndItem.latestSelectedDateObj).endOf('day').format()) {
            that.fpEndItem.setDate(moment(that.fpEndItem.latestSelectedDateObj).endOf('day').format());
        }
        that.event.duration = determineDuration(that.fpStartItem.latestSelectedDateObj, that.fpEndItem.latestSelectedDateObj, that.durationOptions);
    };

    that.startDatePostSetup = function(fpItem) {
        that.fpStartItem = fpItem;
        that.fpStartItem.setDate(that.event.start);
    };

    that.endDatePostSetup = function(fpItem) {
        that.fpEndItem = fpItem;
        that.fpEndItem.setDate(that.event.end);

        $scope.$watch(function() {
            return that.event.duration;
        }, function(newVal, oldVal) {
            if (newVal !== oldVal) {
                let newEnd = that.fpEndItem.latestSelectedDateObj;
                if (that.event.duration.value !== 'custom') {
                    newEnd = moment(that.fpStartItem.latestSelectedDateObj).add(that.event.duration.value, 'minutes').format();
                }
                that.fpEndItem.setDate(newEnd);
            }
        });

        $scope.$watch(function() {
            return that.event.allDay;
        }, function(newVal, oldVal) {
            if (newVal !== oldVal) {
                if (that.event.allDay) {
                    that.fpStartItem.setDate(moment(that.fpStartItem.latestSelectedDateObj).startOf('day').format());
                    that.fpEndItem.setDate(moment(that.fpEndItem.latestSelectedDateObj).endOf('day').format());

                    // Disable time picker while allDay is selected
                    that.fpStartItem.config.enableTime = false;
                    that.fpEndItem.config.enableTime = false;
                    angular.element(that.fpStartItem.calendarContainer).removeClass('hasTime');
                    angular.element(that.fpEndItem.calendarContainer).removeClass('hasTime');
                } else {
                    // Enable time picker now that allDay has been deselected
                    that.fpStartItem.config.enableTime = true;
                    that.fpEndItem.config.enableTime = true;
                    angular.element(that.fpStartItem.calendarContainer).addClass('hasTime');
                    angular.element(that.fpEndItem.calendarContainer).addClass('hasTime');
                }
            }
        });

        $scope.$watch(function() {
            return that.event.repeat;
        }, function(repeat) {
            if (angular.isDefined(repeat)) {
                that.repeatEveryOptions = [{
                    phrase: $translate.instant((PLURALITY[repeat.value] || {})[0]),
                    value: 1
                }];
                for (var i = 2; i <= 30; i++) {
                    that.repeatEveryOptions.push({
                        phrase: $translate.instant((PLURALITY[repeat.value] || {})[1], { n: i }),
                        value: i
                    });
                }
                if (!that.repeatEvery) {
                    that.repeatEvery = that.repeatEveryOptions[0];
                }
            }
        });
    };

    that.repeatOptions = [
        {
            name: $translate.instant('NON_REPEATING'),
            value: 'non_repeating'
        },
        {
            name: $translate.instant('WEEKLY'),
            value: 'week'
        },
        {
            name: $translate.instant('MONTHLY'),
            value: 'month'
        },
        {
            name: $translate.instant('YEARLY'),
            value: 'year'
        }
    ];

    that.durationOptions = [
        {
            value: 5,
            display: $translate.instant('N_MINUTES', { n: 5 })
        },
        {
            value: 10,
            display: $translate.instant('N_MINUTES', { n: 10 })
        },
        {
            value: 15,
            display: $translate.instant('N_MINUTES', { n: 15 })
        },
        {
            value: 30,
            display: $translate.instant('N_MINUTES', { n: 30 })
        },
        {
            value: 45,
            display: $translate.instant('N_MINUTES', { n: 45 })
        },
        {
            value: 60,
            display: $translate.instant('ONE_HOUR')
        },
        {
            value: 90,
            display: $translate.instant('ONE_HOUR') + ' ' + $translate.instant('N_MINUTES', { n: 30 })
        },
        {
            value: 'custom',
            display: $translate.instant('CUSTOM_END_TIME')
        }
    ];

    if (that.type === 'EDIT' && !_.isEmpty(event)) {
        that.event = {
            name: event.name,
            description: event.description,
            start: moment(event.start).tz(timezone).format(),
            end: moment(event.end).tz(timezone).format(),
            repeat: event.repeats.repeat_type
        };
        that.event.duration = determineDuration(that.event.start, that.event.end, that.durationOptions);
        // if an event starts at 12:00am and ends at 11:59pm, we say its all day
        that.event.allDay = moment(that.event.start).isSame(moment(that.event.start).startOf('day'))
            && moment(that.event.end).isSame(moment(that.event.end).seconds(0).endOf('day'), 'minute');

        if (event.repeats.repeat_type !== 'non_repeating') {
            that.event.repeatEvery = event.repeats.repeats_frequency;
            that.event.occurrences = event.repeats.repeats_num;
        }

    } else {
        that.event = {
            repeatEvery: '1',
            occurrences: 2,
            allDay: false
        };

        that.event.start = moment().tz(timezone).add((30 - moment().tz(timezone).minute() % 30), 'minutes').seconds(0).format();
        that.event.end = moment(that.event.start).tz(timezone).add(30, 'minutes').format();
        that.event.duration = determineDuration(that.event.start, that.event.end, that.durationOptions);
    }

    that.repeats = [];
    for (let i = 2; i <= 30; i++) {
        that.repeats.push({
            phrase: $translate.instant('N_TOTAL_OCCURRENCES', { n: i }),
            value: i - 1
        });
    }

    that.submit = function() {

        $scope.isSaving = true;

        var formatted = {
                name: that.event.name,
                description: that.event.description || '',
                startTime: that.event.start,
                endTime: that.event.end,
                repeat: {
                    repeats: that.event.repeat.value
                }
            },
            APIPromise;

        if (formatted.repeat.repeats !== 'non_repeating') {
            formatted.repeat.repeats_frequency = +that.event.repeatEvery.value;
            formatted.repeat.repeats_num = +that.event.occurrences.value;
        }

        if (that.type === 'NEW') {
            APIPromise = calendarService.createEvent.bind(null, that.facility_id, formatted);
        } else {
            APIPromise = calendarService.updateEvent.bind(null, that.event_id, that.facility_id, formatted);
        }

        return APIPromise()
        .then(function() {
            Analytics.trackEvent('facilityCalendar', 'event', that.type, that.event_id);

            $rootScope.$broadcast('calendarEvents:update', formatted.startTime);
        })
        .catch(function(e) {
            errorService.addError(that.type + '_EVENT_ERROR', e);
        })
        .finally(function() {
            $scope.closeThisDialog();
            $scope.isSaving = false;
        });
    };

    that.deleteEvent = function() {
        $scope.deleting = true;
        calendarService.removeEvent(event.id, that.facility_id)
        .then(function() {
            Analytics.trackEvent('facilityCalendar', 'event', 'delete', event.id);

            $rootScope.$broadcast('calendarEvents:update', event.start);
        })
        .catch(function(e) {
            errorService.addError('DELETE_EVENT_ERROR', e);
        })
        .finally(function() {
            $scope.deleting = false;
            $scope.closeThisDialog();
        });
    };

    function determineDuration(date1, date2, options) {
        var diff = moment(date2).diff(moment(date1), 'minutes'),
            option = _.where(options, { value: diff });
        return option.length ? option[0] : _.where(options, { value: 'custom' })[0];
    }
});



// WEBPACK FOOTER //
// ./src/app/controllers/calendarEventCtrl.js